import { useState, useEffect } from "react";
import storeLocatorService from "../../../_foundation/apis/transaction/storeLocator.service";
import { useJsApiLoader } from "@react-google-maps/api";
import { useDispatch } from "react-redux";
import { STORES_LIST_GET_REQUEST_ACTION, STORES_RESET_ACTION } from "../../../redux/actions/stores";
import { searchType } from "../../../types/store-types";
import { useSelector } from "react-redux";
import { storesListSelector } from "../../../redux/selectors/stores";
import { STORELISTRADIUS } from "../../../_foundation/constants/common";
import { GMAPS_API_LOADER_CONFIG } from "../../../configs/common";

export const useStorelocatorByLocation = (zipCode: string | null, isFromAppointmentForm) => {
  const { isLoaded } = useJsApiLoader(GMAPS_API_LOADER_CONFIG);

  const dispatch = useDispatch();
  const [lastZipCode, setLastZipCode] = useState<string | null>(null);

  const getStoresList = async (postalCode) => {
    dispatch(STORES_RESET_ACTION());
    const data = await storeLocatorService.getLatLong(postalCode);
    const latitude = data.lat;
    const longitude = data.long;
    const parameters: any = {
      latitude: String(latitude),
      longitude: String(longitude),
      radius: STORELISTRADIUS,
      siteLevelStoreSearch: false,
    };
    if (isFromAppointmentForm) {
      parameters.query = { attributeName: "isAppointment", attributeValue: "1" };
    }
    dispatch(
      STORES_LIST_GET_REQUEST_ACTION({
        parameters,
        type: searchType.geoLocalisation,
        productData: null,
      })
    );
  };

  useEffect(() => {
    if (isLoaded && zipCode && zipCode?.length === 5 && zipCode !== lastZipCode) {
      getStoresList(zipCode);
      setLastZipCode(zipCode);
    } else if (!zipCode || zipCode?.length !== 5) {
      setLastZipCode(null);
      dispatch(STORES_RESET_ACTION());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [zipCode, isLoaded]);

  const nearestStores = useSelector(storesListSelector);

  return nearestStores;
};
